const BouncingDotsLoader = () => {
  return (
    <section className="container background_grey_light">
      <div className="sini_container_animation">
        <div className="sini_shape_animation sini_circle_1"></div>
        <div className="sini_shape_animation sini_circle_2"></div>
        <div className="sini_shape_animation sini_circle_3"></div>
      </div>
    </section>
  );
};

export default BouncingDotsLoader;
